import { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { reInitMenu } from '@/_metronic/helpers';
import { FooterWrapper } from '@/_metronic/layout/components/footer';
import { HeaderWrapper } from '@/_metronic/layout/components/header';
import { ScrollTop } from '@/_metronic/layout/components/scroll-top';
import { Sidebar } from '@/_metronic/layout/components/sidebar';
import { ToolbarWrapper } from '@/_metronic/layout/components/toolbar';
import { PageDataProvider } from '@/_metronic/layout/core';
import GettingStartedWidget from '@/app/pages/home/components/setup-guide/GettingStartedWidget';
import { GettingStartedWidgetProvider } from '@/app/pages/home/components/setup-guide/GettingStartedWidgetContext';
import { AgentContextProvider } from '@/app/modules/agent-chat/context/AgentContextProvider';
import AgentChatWidget from '@/app/modules/agent-chat/components/AgentChatWidget';
import { TicketComposerProvider } from '@/app/modules/tickets/context/TicketComposerProvider';
import EntryModals from '@/app/modules/announcements/components/EntryModals';
import { useInterfaceLayout } from '@/app/modules/interface-appearance/InterfaceLayoutProvider';

const MasterLayout = () => {
  const location = useLocation();
  const { preferences } = useInterfaceLayout();
  useEffect(() => {
    reInitMenu();
  }, [location.key]);

  return (
    <PageDataProvider>
      <GettingStartedWidgetProvider>
        <AgentContextProvider>
          <TicketComposerProvider>
            <div
              className="d-flex flex-column flex-root app-root"
              data-interface-content={preferences.centeredContent ? 'centered' : 'fluid'}
              data-interface-density={preferences.compact ? 'compact' : 'comfortable'}
              data-interface-header-fixed={preferences.fixedHeader}
              data-kt-app-sidebar-hoverable="true"
              data-kt-app-sidebar-minimize={preferences.sidebarMinimized ? 'on' : undefined}
              id="kt_app_root"
            >
              <div className="app-page flex-column flex-column-fluid" id="kt_app_page">
                <HeaderWrapper />

                <div className="app-wrapper flex-column flex-row-fluid" id="kt_app_wrapper">
                  <Sidebar />
                  <div className="app-main flex-column flex-row-fluid" id="kt_app_main">
                    <div className="d-flex flex-column flex-column-fluid">
                      <ToolbarWrapper />
                      <div className="app-content flex-column-fluid " id="kt_content_container">
                        <Outlet />
                      </div>
                    </div>
                    <FooterWrapper />
                  </div>
                </div>
              </div>
            </div>
            <ScrollTop />
            <GettingStartedWidget />
            <AgentChatWidget />
            <EntryModals />
          </TicketComposerProvider>
        </AgentContextProvider>
      </GettingStartedWidgetProvider>
    </PageDataProvider>
  );
};

export { MasterLayout };
